module.exports = __webpack_public_path__ + "img/plowe-sm.22db4423.png";